<template>
	<div class="journal-details i_maxW">
		<template v-for="item of details">
			<div class="space-crumbs">
				<router-link to="/teach">名师中心</router-link>
				<span @click="goBack()"><i>></i>{{item.user_name}}</span>
				<span><i>></i>{{item.name}}</span>
			</div>
			<div class="j-details clear">
				<div class="j-details-l fl">
					<h3>{{item.name}}</h3>
					<div class="j-details-l-user">
						<span>
							<img :src="BASE_URL + item.avatar_path">
						</span>
						<span>{{item.user_name}}</span>
						<span>发表于  {{item.create_time}} </span>
					</div>
					<div class="j-details-l-cont" v-html="item.profile"></div>
				</div>
				<div class="j-details-r fr">
					<div class="j-details-r-h">
						<i class="ipng icon_mingshi_rizhi2"></i>
						<span>该老师的其它日志</span>
					</div>
					<ul>
						<template v-if="journalList.length !== 0">
							<li class="j-details-r-ls clear" v-for="item of journalList" >
								<router-link to="">{{item.name}}</router-link>
								<span>{{item.create_time}}</span>
							</li>
						</template>

						<li class="j-details-r-ls2 clear" v-else>
							<span>暂无相关信息</span>
						</li>
					</ul>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	
	export default{
		data(){
			return {
				details: null,
				journalList: [],
			}
		},
		created(){
			this.getdetails()
			this.getjournalList()
		},
		mounted(){
			// this.$nextTick(function () {
				
			// })
		},
		methods: {
			goBack(){
				this.$router.back(-1)
			},
			getdetails(){
				let success = (res =>{
					this.details = res.data;
				});
				this.$ajax({
					url: 'api/resource/journal',
					method: 'get',
					params: {
						id: this.$route.query.id,
						data_type: 0
					},
					func: {success: success}
				})
			},
			getjournalList(){
				let success = (res =>{
					this.journalList = res.data;
				});
				this.$ajax({
					url: 'api/resource/journal',
					method: 'get',
					params: {
						create_id: this.$route.query.id,
						data_type: 0,
						status: 1,
						orderby: 'time',
						orderby_desc: 'DESC',
						authority: 1,
					},
					func: {success: success}
				})
			}
		}
	}
</script>